/* =============================================================
   MUTE OFFICE Reviews-Renderer (PDP + Homepage)
   v2.0 — 2026-04-26
   - DSGVO-Gate via window.MUTE_CONSENT.userOptedIn('analytics')
   - Public-API: judge.me/reviews/reviews_for_widget
   - srcset/sizes/lazy für scharfe Bilder
   - Promise-Pool (Concurrency 8) + sessionStorage-Cache 30min
   - AbortController bei Page-Unload
   ============================================================= */
(function(){
  'use strict';

  /* ── Helpers ──────────────────────────────────────────────── */
  function escapeHtml(s){
    if(!s && s !== 0) return '';
    return String(s).replace(/[&<>"']/g, function(c){
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
  }
  function stars(n){
    n = Math.round(parseFloat(n)||0);
    var s = '';
    for(var i=0;i<5;i++){ s += i<n ? '★' : '☆'; }
    return s;
  }
  function fmtDate(iso){
    if(!iso) return '';
    try{
      var d = new Date(iso);
      var diff = (Date.now()-d.getTime())/86400000;
      if(diff < 1) return 'heute';
      if(diff < 2) return 'vorgestern';
      if(diff < 14) return Math.floor(diff)+' Tage';
      if(diff < 60) return Math.floor(diff/7)+' Wochen';
      if(diff < 730) return Math.floor(diff/30)+' Monate';
      return Math.floor(diff/365)+' Jahre';
    }catch(e){ return ''; }
  }
  function lightbox(src, klass){
    var lb = document.createElement('div');
    lb.className = klass;
    lb.innerHTML = '<img src="'+escapeHtml(src)+'" alt="Bewertungs-Foto">';
    lb.addEventListener('click', function(){ lb.remove(); });
    document.body.appendChild(lb);
  }
  function consentOk(){
    if(window.MUTE_CONSENT && typeof window.MUTE_CONSENT.userOptedIn === 'function'){
      return !!window.MUTE_CONSENT.userOptedIn('analytics');
    }
    return false;
  }
  function whenConsent(cb){
    if(consentOk()){ cb(); return; }
    document.addEventListener('visitorConsentCollected', cb);
    document.addEventListener('trackingConsentAccepted', cb);
    var tries = 0;
    var iv = setInterval(function(){
      tries++;
      if(consentOk()){ cb(); clearInterval(iv); }
      else if(tries > 30){ clearInterval(iv); }
    }, 500);
  }

  /* ── Promise-Pool ─────────────────────────────────────────── */
  function pool(items, limit, fn){
    return new Promise(function(resolve){
      var results = [], idx = 0, active = 0, done = 0;
      if(items.length === 0){ resolve([]); return; }
      function next(){
        while(active < limit && idx < items.length){
          (function(i){
            active++;
            fn(items[i]).then(function(v){ results[i] = v; }).catch(function(){ results[i] = null; }).then(function(){
              active--; done++;
              if(done === items.length) resolve(results);
              else next();
            });
          })(idx++);
        }
      }
      next();
    });
  }

  /* ═════════════════════════════════════════════════════════════
     PDP Renderer — single product
     ═════════════════════════════════════════════════════════════ */
  function initPdpRenderer(){
    var containers = document.querySelectorAll('.mute-reviews[data-product-id]');
    if(containers.length === 0) return;

    containers.forEach(function(container){
      if(container.dataset.muteInited) return;
      container.dataset.muteInited = '1';

      whenConsent(function(){
        var pid = container.dataset.productId;
        var domain = container.dataset.shopDomain;
        var url = 'https://judge.me/reviews/reviews_for_widget'
                + '?shop_domain=' + encodeURIComponent(domain)
                + '&platform=shopify'
                + '&product_id=' + encodeURIComponent(pid);
        fetch(url).then(function(r){ return r.json(); }).then(function(data){
          renderPdp(container, data);
        }).catch(function(){
          container.innerHTML = '<div class="mute-reviews__empty">Bewertungen konnten nicht geladen werden.</div>';
        });
      });
    });
  }

  function renderPdp(container, data){
    if(!data || !data.reviews || data.reviews.length === 0){
      container.innerHTML = '<div class="mute-reviews__empty">Noch keine Bewertungen — sei der/die erste.</div>';
      return;
    }
    var html = '';
    var allPics = [];
    data.reviews.forEach(function(r){
      if(r.pictures_urls && r.pictures_urls.length){
        r.pictures_urls.forEach(function(p){
          allPics.push({
            compact: p.compact || p.small || p.original,
            huge: p.huge || p.original
          });
        });
      }
    });
    if(allPics.length){
      html += '<div class="mute-reviews__photo-gallery">';
      allPics.forEach(function(p){
        html += '<a data-pic-full="'+escapeHtml(p.huge)+'">';
        html += '<img src="'+escapeHtml(p.compact)+'"'
              + ' srcset="'+escapeHtml(p.compact)+' 1x, '+escapeHtml(p.huge)+' 2x"'
              + ' alt="Bewertungsfoto" loading="lazy"></a>';
      });
      html += '</div>';
    }
    html += '<div class="mute-reviews__grid">';
    data.reviews.forEach(function(r){
      html += '<div class="mute-rev">';
      html += '<div class="mute-rev__head"><div>';
      html += '<div class="mute-rev__stars">'+stars(r.rating)+'</div>';
      html += '<div class="mute-rev__name">'+escapeHtml(r.reviewer_name||'Anonym')+'</div>';
      html += '<div class="mute-rev__date">'+fmtDate(r.created_at)+'</div>';
      html += '</div>';
      if(r.verified_buyer){ html += '<span class="mute-rev__verified">Verifiziert</span>'; }
      html += '</div>';
      html += '<div class="mute-rev__body">'+(r.body_html||'')+'</div>';
      if(r.pictures_urls && r.pictures_urls.length){
        html += '<div class="mute-rev__pics">';
        r.pictures_urls.forEach(function(p){
          var thumb = p.compact || p.small || p.original;
          var huge = p.huge || p.original;
          html += '<a data-pic-full="'+escapeHtml(huge)+'">';
          html += '<img src="'+escapeHtml(thumb)+'"'
                + ' srcset="'+escapeHtml(thumb)+' 1x, '+escapeHtml(huge)+' 2x"'
                + ' alt="Bewertungsfoto" loading="lazy"></a>';
        });
        html += '</div>';
      }
      html += '</div>';
    });
    html += '</div>';
    container.innerHTML = html;
    container.querySelectorAll('a[data-pic-full]').forEach(function(a){
      a.addEventListener('click', function(e){
        e.preventDefault();
        lightbox(a.dataset.picFull, 'mute-reviews__lightbox');
      });
    });
  }

  /* ═════════════════════════════════════════════════════════════
     HOMEPAGE Renderer — alle Produkte aggregiert
     ═════════════════════════════════════════════════════════════ */
  var HOME_CACHE_KEY = 'mute_reviews_homepage_v2';
  var HOME_CACHE_TTL = 30 * 60 * 1000;

  function readHomeCache(){
    try{
      var raw = sessionStorage.getItem(HOME_CACHE_KEY);
      if(!raw) return null;
      var p = JSON.parse(raw);
      if(!p || !p.t) return null;
      if(Date.now() - p.t > HOME_CACHE_TTL){
        sessionStorage.removeItem(HOME_CACHE_KEY);
        return null;
      }
      return p;
    }catch(e){ return null; }
  }
  function writeHomeCache(reviews, photos){
    try{
      sessionStorage.setItem(HOME_CACHE_KEY, JSON.stringify({
        t: Date.now(), reviews: reviews, photos: photos
      }));
    }catch(e){}
  }

  function initHomeRenderer(){
    var container = document.querySelector('.mute-home-reviews');
    if(!container) return;
    if(container.dataset.muteInited) return;
    container.dataset.muteInited = '1';

    whenConsent(function(){
      var cached = readHomeCache();
      if(cached){
        renderHome(container, cached.photos, cached.reviews);
        return;
      }

      var idsRaw = container.dataset.productIds || '';
      var domain = container.dataset.shopDomain;
      var ids = idsRaw.split(',').map(function(s){ return s.trim(); }).filter(function(s){ return s.length > 0; });
      ids = ids.filter(function(v,i,a){ return a.indexOf(v) === i; });

      if(ids.length === 0){
        container.innerHTML = '<div class="mute-home-reviews__empty">Noch keine Bewertungen.</div>';
        return;
      }

      var abortCtrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var signal = abortCtrl ? abortCtrl.signal : undefined;
      window.addEventListener('beforeunload', function(){
        if(abortCtrl){ try{ abortCtrl.abort(); }catch(e){} }
      });

      pool(ids, 8, function(pid){
        var url = 'https://judge.me/reviews/reviews_for_widget'
                + '?shop_domain=' + encodeURIComponent(domain)
                + '&platform=shopify'
                + '&product_id=' + encodeURIComponent(pid);
        return fetch(url, { signal: signal }).then(function(r){ return r.json(); }).catch(function(){ return null; });
      }).then(function(results){
        var allReviews = [];
        var allPhotos = [];
        var seenReviewIds = {};
        results.forEach(function(data){
          if(!data || !data.reviews) return;
          data.reviews.forEach(function(r){
            if(!r.uuid || seenReviewIds[r.uuid]) return;
            seenReviewIds[r.uuid] = true;
            if(r.rating && parseInt(r.rating) >= 4){
              allReviews.push({
                review: r,
                productTitle: data.product_name || '',
                productUrl: r.product_url || ''
              });
            }
            if(r.pictures_urls && r.pictures_urls.length){
              r.pictures_urls.forEach(function(p){
                allPhotos.push({
                  compact: p.compact || p.small || p.original,
                  huge: p.huge || p.original,
                  productTitle: data.product_name || ''
                });
              });
            }
          });
        });
        allReviews.sort(function(a, b){
          var aPic = (a.review.pictures_urls && a.review.pictures_urls.length) ? 1 : 0;
          var bPic = (b.review.pictures_urls && b.review.pictures_urls.length) ? 1 : 0;
          if(aPic !== bPic) return bPic - aPic;
          return new Date(b.review.created_at).getTime() - new Date(a.review.created_at).getTime();
        });
        writeHomeCache(allReviews, allPhotos);
        renderHome(container, allPhotos, allReviews);
      }).catch(function(){
        container.innerHTML = '<div class="mute-home-reviews__empty">Bewertungen konnten nicht geladen werden.</div>';
      });
    });
  }

  function updateHomeHeader(reviewCount, avgRating){
    var bigEl = document.querySelector('.reviews__big');
    var countEl = document.querySelector('.reviews__count');
    if(bigEl && avgRating){ bigEl.textContent = avgRating; }
    if(countEl){
      countEl.textContent = ' ' + reviewCount + ' VERIFIZIERTE BEWERTUNG' + (reviewCount === 1 ? '' : 'EN');
    }
  }

  function renderHome(container, photos, reviews){
    var totalCount = reviews.length;
    var avgRating = totalCount > 0
      ? (reviews.reduce(function(s, it){ return s + (parseInt(it.review.rating)||0); }, 0) / totalCount).toFixed(2)
      : null;
    updateHomeHeader(totalCount, avgRating);

    if(reviews.length === 0 && photos.length === 0){
      container.innerHTML = '<div class="mute-home-reviews__empty">Noch keine Bewertungen — sei der/die erste.</div>';
      return;
    }
    var html = '';
    if(photos.length){
      html += '<div class="mute-home-reviews__photos">';
      photos.slice(0,12).forEach(function(p){
        html += '<a data-pic-full="'+escapeHtml(p.huge)+'" title="'+escapeHtml(p.productTitle)+'">';
        html += '<img src="'+escapeHtml(p.compact)+'"'
              + ' srcset="'+escapeHtml(p.compact)+' 1x, '+escapeHtml(p.huge)+' 2x"'
              + ' alt="Kunden-Foto: '+escapeHtml(p.productTitle)+'" loading="lazy"></a>';
      });
      html += '</div>';
    }
    html += '<div class="mute-home-reviews__cards">';
    reviews.forEach(function(item){
      var r = item.review;
      html += '<div class="mute-home-rev">';
      html += '<div class="mute-home-rev__head"><div>';
      html += '<div class="mute-home-rev__stars">'+stars(r.rating)+'</div>';
      html += '<div class="mute-home-rev__name">'+escapeHtml(r.reviewer_name||'Anonym')+'</div>';
      html += '<div class="mute-home-rev__date">'+fmtDate(r.created_at)+'</div>';
      if(item.productUrl && item.productTitle){
        html += '<a href="'+escapeHtml(item.productUrl)+'" class="mute-home-rev__product">'+escapeHtml(item.productTitle)+'</a>';
      }
      html += '</div>';
      if(r.verified_buyer){ html += '<span class="mute-home-rev__verified">Verifiziert</span>'; }
      html += '</div>';
      html += '<div class="mute-home-rev__body">'+(r.body_html||'')+'</div>';
      if(r.pictures_urls && r.pictures_urls.length){
        html += '<div class="mute-home-rev__pics">';
        r.pictures_urls.forEach(function(p){
          var thumb = p.compact || p.small || p.original;
          var huge = p.huge || p.original;
          html += '<a data-pic-full="'+escapeHtml(huge)+'">';
          html += '<img src="'+escapeHtml(thumb)+'"'
                + ' srcset="'+escapeHtml(thumb)+' 1x, '+escapeHtml(huge)+' 2x"'
                + ' alt="Bewertungsfoto" loading="lazy"></a>';
        });
        html += '</div>';
      }
      html += '</div>';
    });
    html += '</div>';
    container.innerHTML = html;
    container.querySelectorAll('a[data-pic-full]').forEach(function(a){
      a.addEventListener('click', function(e){
        e.preventDefault();
        lightbox(a.dataset.picFull, 'mute-home-reviews__lightbox');
      });
    });
  }

  /* ── Init beide Renderer ──────────────────────────────────── */
  function init(){
    initPdpRenderer();
    initHomeRenderer();
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
